// Checks whether an e-way bill party (trade name + GSTIN) belongs to the
// selected customer. GST equality is authoritative; otherwise names are
// compared after dropping legal-suffix words, so "KANAGARAJ FIREWORKS" matches
// "KANAGARAJ FIREWORKS FACTORY" but not "STANDARD FIREWORKS (P) LTD".

const STOP_WORDS = new Set([
    "private", "limited", "ltd", "pvt", "p", "co", "company", "factory",
    "industries", "industry", "enterprises", "enterprise", "traders", "trading",
    "agency", "agencies", "corporation", "corp", "the", "and", "of", "ms", "m"
]);

function normalize(str) {
    return String(str || "")
        .toLowerCase()
        .split(/[^a-z0-9]+/)
        .filter((w) => w && !STOP_WORDS.has(w))
        .join("");
}

export function matchesCustomer({ ewbName, ewbGstin, custData }) {
    if (custData?.gst_no && ewbGstin &&
        String(custData.gst_no).trim().toUpperCase() === String(ewbGstin).trim().toUpperCase())
        return true;

    const ewb = normalize(ewbName);
    if (!ewb)
        return false;

    const candidates = [
        normalize(`${custData?.fName || ""} ${custData?.lName || ""}`),
        normalize(custData?.comName)
    ].filter((c) => c.length >= 4);

    return candidates.some((c) => c === ewb ||
        (ewb.length >= 4 && (c.includes(ewb) || ewb.includes(c))));
}
